






import {
  Component,
  Vue
} from 'vue-property-decorator';
import MatomoCookieService from '@/services/matomo/MatomoCookieService';
import MatomoInitializerService from '@/services/matomo/MatomoInitializerService';
import CookiePreferences from '@/cookie-notice/inputs/CookiePreferences.vue';
import GoogleCookieService from '@/services/google/GoogleCookieService';

@Component({
  components: {CookiePreferences}
})
export default class CookieModal extends Vue {
  private matomoCookieService = MatomoCookieService.singleton();
  private googleCookieService = GoogleCookieService.singleton();
  private matomoInitializerService = MatomoInitializerService.singleton();

  public show = !this.matomoCookieService.isCookieSet() ||
      !this.googleCookieService.isCookieSet();


  private closeDialog() {
    this.show = false;
    this.matomoInitializerService.initializeMatomo();
  }

}
